import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IrisApiClient, ApiUrl } from '@iris/api-query';
import { TranslateServiceConfig, TranslationObject } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
@ApiUrl('/translations/static-translation')
export class TranslationKeysService extends IrisApiClient<TranslateServiceConfig> {
  protected readonly httpClient = inject(HttpClient);

  constructor() {
    super(inject(HttpClient));
  }

  @ApiUrl('~/FRONTEND')
  query(): Observable<TranslationObject> {
    return this.httpClient.get<TranslationObject>(this.url());
  }

  /**
   * Get translations for a specific language
   * @param language Language code (e.g., 'en', 'fr')
   */
  @ApiUrl('~/FRONTEND/{language}')
  getTranslationsByLanguage(language: string): Observable<TranslationObject> {
    return this.httpClient.get<TranslationObject>(this.url({ language }));
  }
}
